import type { RootState } from '@web/app/store'
import { profileApi } from '@web/entities/user/api/profile.api'

const selectProfileQuery = profileApi.endpoints.getProfile.select()

export const selectUser = (state: RootState) =>
  selectProfileQuery(state).data ?? null
export const selectAuthStatus = (state: RootState) => state.auth.authStatus
